import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import styles from "../CustomDistributionMethod/CustomDistributionMethod.module.scss";
import circlePlus from '../../assets/images/icon-button.svg';
import DestinationOption from "../../components/DestinationOption/DestinationOption";
import HelpBox from "../../components/HelpBox/HelpBox";
import PageWrapper from "../../components/PageWrapper/PageWrapper";
import ProgressBar from "../../components/Progress/ProgressBar/ProgressBar";
import ProgressButtons from "../../components/Progress/ProgressButtons/ProgressButtons";
import RMLConnection from "../../components/RMLConnection/RMLConnection";
import FundDisplayText from "../ProportionateDistributionMethod/FundDisplayText";
import Loader from "../../components/Loader/Loader";
import ErrorPage from "../landing/ErrorPage";
import {
  getNonRetirementUnLockFunds,
  getNonRetirementFundsCount,
  getNonRetirementLockedFunds,
  getBalanceAsOfDate,
  getExchangeLoaded,
  getRMDfunds,
  isReinvestmentEmpty,
} from "../../redux/modules/UserFunds/userFunds.selectors";
import {
  CUSTOM_DISTRIBUTION_METHOD_STEP,
  REINVEST_STEP,
  TOLL_FREE_NUMBER,
  FREQUENCY_STEP,
  DISTRIBUTION_METHOD_STEP,
  stepNavigation, REINVEST_TO_NEW,
} from "../../settings/settings";
import { moduleActions } from "../../redux/modules/index";
import { sortingFn } from "../../utils/fund-utils";
import {
  getSelectedReinvestment,
  getSelectedDistribution, getSelectedDestination,
} from "../../redux/modules/shoppingCart/shoppingCart.selectors";

import { compose } from "redux";
import { withRouter } from "react-router-dom";
import {
  getHouseholdSegmentInformation,
  getPersonalInformationData
} from "../../redux/modules/PersonalInformation/personalInformation.selectors";
import {
  openModal as openModalAction,
  REINVEST_TO_NEW_CORE,
  SUCCESS_MODAL
} from "../../redux/modules/modals/modals.module";
import {updateSelectedReinvestment} from "../../redux/modules/shoppingCart/shoppingCart.module";

const CustomDistributionMethod = (props) => {
  const dispatch = useDispatch();
  const fundCount = useSelector(getNonRetirementFundsCount);
  const fullName = useSelector(getPersonalInformationData).fullName;
  const selectedDestination = useSelector(getSelectedDestination);
  const {
    individualLockedList,
    transferLockedList,
    jointLockedList,
    jointTransferLockedList,
  } = useSelector(getNonRetirementLockedFunds);
  const balanceAsOfDate = useSelector(getBalanceAsOfDate);
  const exchangeSet = useSelector(getExchangeLoaded);
  const {
    individualUnLockedList,
    jointUnLockedList,
    transferUnLockedList,
    jointTransferUnLockedList,
  } = useSelector(getNonRetirementUnLockFunds);

  const [state, setState] = useState({
    individual: individualUnLockedList,
    joint: jointUnLockedList,
    transfer: transferUnLockedList,
    jointTransfer: jointTransferUnLockedList,
  });

  const isLoading = useSelector(
    (state) => state.userFunds.isExchangeFundsLoading
  );

  const fund = useSelector(getSelectedReinvestment).fund;

  const selectedDistribution = useSelector(getSelectedDistribution);
  const { allFunds: fundList } = useSelector(getRMDfunds);
  const hasError = useSelector((state) => state.userFunds.hasError);
  if (exchangeSet) {
    setState({
      individual: individualUnLockedList,
      joint: jointUnLockedList,
      transfer: transferUnLockedList,
      jointTransfer: jointTransferUnLockedList,
    });

    dispatch(moduleActions.resetSearch());
  }

  const checkForReinvestFunds = useSelector(isReinvestmentEmpty);
  const [selectFund, setSelectedFund] = useState(fund ? fund : {});

  /* Getting household entity segment information */
  const enableDistributionMethod = useSelector(getHouseholdSegmentInformation);
   /* Navigate to Multiple funds in distribution page when the user is in Enhanced Personal Services */
  const showCustomDistributionMethod =
    !enableDistributionMethod || fundList.length === 1;
  useEffect(() => {
    if(selectedDestination === REINVEST_TO_NEW && fund !== {}) {
      setSelectedFund(fund);
    }
  }, [fund]);
  const options = (list, text) => {
    if (list.length > 0) {
      return (
        <>
          <div className={styles["reinvest-rmd-title"]}> {text}</div>
          {list.map((fund, index) => (
            <DestinationOption
              key={index}
              selectOption={() => setSelectedFund(fund)}
              isSelected={selectFund && fund.uniqueKey === selectFund.uniqueKey}
              selectable={!Boolean(fund.lockedText)}
              addressLock={Boolean(fund.lockedText)}
              blockContainer={true}
              optionText={
                <FundDisplayText
                  newFund={false}
                  retirement={false}
                  fund={fund}
                  reinvestBlock={!Boolean(fund.lockedText)}
                  lock={Boolean(fund.lockedText)}
                  balanceAsOfDate={balanceAsOfDate}
                  dispatch={dispatch}
                />
              }
              value={1}
              disabled={Boolean(fund.lockedText)}
            />
          ))}
        </>
      );
    }
  };
  const newFund = (list, text) => {
    if (list.length > 0) {
      return (
        <>
          <div className={styles["reinvest-rmd-title"]}> {text}</div>
          {list.map((fund, index) => (
            <div>
            <DestinationOption
              key={index}
              selectOption={() => setSelectedFund(fund)}
              isSelected={selectFund && fund.uniqueKey === selectFund.uniqueKey}
              selectable={false}
              addressLock={Boolean(fund.lockedText)}
              blockContainer={true}
              optionText={
                <FundDisplayText
                  newFund={true}
                  retirement={false}
                  fund={fund}
                  fullName={fullName}
                  reinvestBlock={!Boolean(fund.lockedText)}
                  lock={Boolean(fund.lockedText)}
                  balanceAsOfDate={balanceAsOfDate}
                  dispatch={dispatch}
                />
              }
              value={1}
              disabled={Boolean(fund.lockedText)}
            />
            </div>
          ))}
        </>
      );
    }
  };

  const lockedFundCount =
    individualLockedList.length +
    transferLockedList.length +
    jointLockedList.length +
    jointTransferLockedList.length;

  const [checkForLockedFunds, setCheckForLockedFunds] = useState(false);
  const updateFundList = () => {
    setState({
      individual: [...individualUnLockedList, ...individualLockedList].sort(
        sortingFn
      ),
      joint: [...jointUnLockedList, ...jointLockedList].sort(sortingFn),
      transfer: [...transferUnLockedList, ...transferLockedList].sort(
        sortingFn
      ),
      jointTransfer: [
        ...jointTransferUnLockedList,
        ...jointTransferLockedList,
      ].sort(sortingFn),
    });
    setCheckForLockedFunds(true);
    window.scrollTo(0, 0);
  };

  if (isLoading) {
    return (
      <div className={styles.loading}>
        <Loader isVisible={true} />
      </div>
    );
  }

  if (hasError) {
    return <ErrorPage />;
  }

  return (
    <div className="rmd-distribution-wrapper">
      <div className="sticky-header">
        <div className="heading">Auto-RMD Setup</div>
        <ProgressButtons
          edit={props.edit}
          currentStep={REINVEST_STEP}
          currentSelection={fund}
          previousStep={
            showCustomDistributionMethod
              ? DISTRIBUTION_METHOD_STEP
              : selectedDistribution
          }
          payload={selectFund}
          nextStep={FREQUENCY_STEP}
          {...props}
          showBackButton={true}
          backDisabled={false}
          disabled={!selectFund.uniqueKey}
        >
          <ProgressBar completedSteps={[0]} activeIndex={1} />
        </ProgressButtons>
      </div>
      <PageWrapper step={CUSTOM_DISTRIBUTION_METHOD_STEP} isHelpCol={true}>
        <div className="scroll-wrapper">
          <div className="reinvest-title" style={{ marginBottom: 16 }}>
            Where do you want to reinvest{" "}
            <span className="orphan-line"> your RMD?</span>
          </div>
          <div className={styles["option-container"]}>
            <div className={styles[""]}>
              {options(state.individual, "Individual")}
              {options(state.joint, "Joint Tenant")}
              {options(state.transfer, "Transfer On Death")}
              {options(state.jointTransfer, "Joint Transfer On Death")}
            </div>

            {!checkForLockedFunds && lockedFundCount > 0 && (
              <div className={styles["locked-div"]}>
                <span className={styles["lockedcount-text"]}>
                  Investments available for reinvestment are displayed.
                </span>{" "}
                <button
                  id="show-more-reinvest-btn"
                  className={styles["lockedcount"]}
                  onClick={() => updateFundList()}
                >
                  {lockedFundCount} out of {fundCount} investments are
                  ineligible
                </button>
              </div>
            )}
            {(checkForReinvestFunds || selectedDestination === REINVEST_TO_NEW) && (
              <div>
                {Object.keys(fund).length === 0 && (
                  <span>
                   <div className={styles["reinvest-rmd-title"]}>Individual</div>
                   <div className={styles["container"]}>
                     <button
                       id="show-more-reinvest-btn"
                       className={styles["nonretirementaccount"]}
                       onClick={() =>
                         dispatch(openModalAction(REINVEST_TO_NEW_CORE))
                       }
                     >
                      <div className={styles["text-next-to-img"]}>
                        <img src={circlePlus} alt='blue circle with plus sign' className={styles["img-img"]}/>
                        <span className={styles["text-next-to-img-text"]}>Select a new fund</span>
                      </div>
                    </button>
                  </div>
                 </span>
                )}
                {Object.keys(fund).length !== 0 && (
                  <div className={styles["option-container"]}>
                    <div className={styles[""]}>
                      {newFund([fund], "Individual")}
                    </div>
                  </div>
                )}
              </div>
            )}
            <HelpBox step={REINVEST_STEP} />
            <RMLConnection phoneNumber={TOLL_FREE_NUMBER} />
          </div>
        </div>
      </PageWrapper>
    </div>
  );
};

export default compose(withRouter)(CustomDistributionMethod);
